import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { AppState } from '@client/common/redux/store';
import { fetchWishlist, selectWishlist } from '@client/myAccount/wishlists/redux/wishlist/redux';
import { WishlistDetailedType } from 'b2b-common/core/account/api/wishlists';

export const useWishlistEffect = (wishlistId: string): RemoteRecord<WishlistDetailedType> => {
  const dispatch = useDispatch();
  const wishlistDetails = useSelector((state: AppState) => selectWishlist(state, wishlistId));

  useEffect(() => {
    dispatch(fetchWishlist(wishlistId));
  }, [wishlistId]);

  return wishlistDetails;
};
